import { Component, type ErrorInfo, type ReactNode } from 'react';
import { t } from '../i18n';
import { APP_COMMIT_SHORT, APP_VERSION } from '../app/version';

/** Last-resort error screen: a crash never leaves a blank page, and saved games stay intact. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('PAWNED crashed', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="page crash" role="alert">
        <h1>{t('app.title')}</h1>
        <p>{t('error.generic', { message: this.state.error.message })}</p>
        <button type="button" className="btn btn-primary" onClick={() => location.reload()}>
          {t('error.reload')}
        </button>
        <p className="dim">
          {t('app.version', { version: `${APP_VERSION} (${APP_COMMIT_SHORT})` })}
        </p>
      </div>
    );
  }
}
